<template>
    <div class="mt-3 font-12">
        <div v-if="field==='info'">
            <div v-if="deal!==undefined && deal.length!==0" class="panelList">
                <label class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('CREATED_DEAL')}}</label>
                <label class="btn-new p-1 ml-1" v-if="deal.title!==null && deal.title!==undefined"> {{truncate(deal.title, 30)}}</label><br>
                <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                    <label class="btn-new bg-new-gray p-1 mr-1" v-if='deal.cuid && u._id.$oid===deal.cuid.$oid'>{{u.name}} {{u.surName}} </label>
                </template>
                <label class="m-0 color-gray btn-new p-1 " v-if="deal.addDate!==undefined">{{formatDate(new Date(deal.addDate.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                <div class="panelList" v-for="(i,index) in dealLogs" :key="index">
                    <label v-if="i.operation==='deal.close'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('DEAL_CLOSED')}}</label>
                    <label v-else-if="i.operation==='deal.reopen'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('DEAL_TO_REOPEN')}}</label>
                    <label v-else-if="i.operation==='note.deal.create'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('ADD_A_NOTE_TO_AN_DEAL')}}</label>
                    <label v-else-if="i.operation==='note.deal.delete'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('NOTE_DELETED_ON_DEAL')}}</label>
                    <label v-else-if="i.operation==='deal.owner-changed'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('DEAL_OWNER_EXCHANGE')}}</label>
                    <label v-else-if="i.operation==='note.deal.update'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('CHANGE_NOTES_ON_DEAL')}}</label>
                    <label v-else-if="i.operation==='deal.expectedDateChanged'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('ESTIMATED_CLOSING_DATE_CHANGE_AT_DEAL')}}</label>
                    <label v-else-if="i.operation==='deal.updated'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('DEAL_HAS_BEEN_UPDATED')}}</label>
                    <label v-else-if="i.operation==='activity.create'" class="m-0 w-100 light-darkGray-color font-family-bold pb-2">{{$ml.get('ADD_ACTIVITY_TO_DEAL')}}</label>
                    <label class=" p-1"> {{i._message.message}}</label><br>
                    <label class="btn-new bg-new-gray p-1 mr-1">{{i._message.user}}</label>
                    <label class="m-0 btn-new p-1 color-gray">{{i._message.date}}</label>
                    
                </div>
            </div>
            
            
            <div v-if="organization!==undefined && organization.length!==0" class="panelList"> 
                <label class="m-0 w-100 light-darkGray-color font-family-bold">{{$ml.get('CREATED_COMPANY')}}</label>
                <label class="m-0 color-gray" v-if="organization.createdAt!==undefined">{{formatDate(new Date(organization.createdAt.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                    <label class="btn-new bg-new-gray p-1 mt-2" v-if='organization.cuid && u._id.$oid===organization.cuid.$oid'> {{u.name}} {{u.surName}}</label>
                </template>
            </div>
            <div v-if="contact!==undefined && contact.length!==0 && array!=='true'" class="panelList">
                <label class="m-0 w-100 light-darkGray-color font-family-bold">{{$ml.get('CREATED_CONTACT')}}</label>
                <label class="m-0 color-gray" v-if="contact.createdAt!==undefined">{{formatDate(new Date(contact.createdAt.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                <span v-if="contact.cuid!=undefined">
                    <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                        <button class="btn-new bg-new-gray p-1 mt-2" v-if='contact.cuid && u._id.$oid===contact.cuid.$oid'>
                            <span class="" v-if="u.name!==undefined"> {{u.name}}</span>
                            <span class="ml-1" v-if="u.surName!==undefined">{{u.surName}} </span>
                        </button>
                    </template>
                </span>
            </div>
            <template v-if="contact!==undefined && contact.length!==0 && array==='true'">
                <div v-for="(con, cIdx) in contact" :key="cIdx" class="panelList">
                    <label class="m-0 f-14 w-100">{{$ml.get('CREATED_CONTACT')}}</label>
                    <!-- <label class="text-danger m-0 f-14" v-if="contact.createdAt!==undefined">{{formatDate(new Date(contact.createdAt.$date), "Do MMMM YYYY hh:mm:ss")}}</label>-->
                    <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                        <label class="f-14" v-if='con.cuid && u._id.$oid===con.cuid'> {{u.name}} {{u.surName}} - </label>
                    </template>
                    <label class="f-14" v-if="con.n!==undefined"> {{truncate(con.n, 30)}}</label>
                    <label class="f-14" v-if="con.sn!==undefined">{{truncate(con.sn, 30)}} </label>
                </div>
            </template>
        </div>
        <div v-if="field==='dealInfo'">
            <template v-if="deals!==undefined && deals.length!==0">
                <div class="panelList" v-for="(d, dIdx) in deals" :key="dIdx">
                    <label class="text-danger m-0 f-14" v-if="d.addDate!==undefined"><b>{{$ml.get('OPENING')}}:</b> {{formatDate(new Date(d.addDate.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                    <label class="text-danger m-0 f-14" v-if="d.addDate===undefined"><b>{{$ml.get('START_DATE_NOT_FOUND')}}</b></label>
                    <label class="m-0 f-14 clickable" v-show="d.addDate!==undefined" v-if="d.title!==null && d.title!==undefined" @click="dealCard(d._id.$oid)"> - <i class="icon-solid-frsatlar f-14"></i> {{truncate(d.title, 30)}}</label>
                    <template v-if="d.addDate!==undefined">
                        <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                            <label class="f-14" v-if='d.cuid && u._id.$oid===d.cuid.$oid'> - <i class="icon-solid-profil f-14"></i> {{u.name}} {{u.surName}} </label>
                        </template>
                    </template>
                    <br>
                    <div v-if="d.closedDate!==undefined">
                        <label class="text-danger m-0 f-14" v-if="d.closedDate!==undefined"><b>{{$ml.get('FINALIZATION')}}:</b> {{formatDate(new Date(d.closedDate.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                        <label class="m-0 f-14 clickable" v-show="d.closedDate!==undefined" v-if="d.title!==null && d.title!==undefined" @click="dealCard(d._id.$oid)"> - <i class="icon-solid-frsatlar f-14"></i> {{truncate(d.title, 30)}}</label>
                        <template v-if="d.closedDate!==undefined">
                            <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                                <label class="f-14" v-if='d.cuid && u._id.$oid===d.cuid.$oid'> - <i class="icon-solid-profil f-14"></i> {{u.name}} {{u.surName}} </label>
                            </template>
                        </template>
                    </div>
                    <div v-else>
                        <label class="text-danger m-0 f-14" v-if="d.expectedDate!==undefined"><b>{{$ml.get('FINALIZATION')}}:</b> {{formatDate(new Date(d.expectedDate.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                        <label class="text-danger m-0 f-14" v-if="d.expectedDate===undefined"><b>{{$ml.get('DEAL_HAS_NOT_BEEN_FINALIZED_YET')}}</b></label>
                        <label class="m-0 f-14 clickable" v-show="d.expectedDate!==undefined" v-if="d.title!==null && d.title!==undefined" @click="dealCard(d._id.$oid)"> - <i class="icon-solid-frsatlar f-14"></i> {{truncate(d.title, 30)}}</label>
                        <template v-if="d.expectedDate!==undefined">
                            <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                                <label class="f-14" v-if='d.cuid && u._id.$oid===d.cuid.$oid'> - <i class="icon-solid-profil f-14"></i> {{u.name}} {{u.surName}} </label>
                            </template>
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="field==='deal'">
            <div v-if="data.length===0 || data===undefined">
                <label class="m-0 f-14 note p-0 w-100 commit">{{$ml.get('NO_FINALIZED_ACTIVITY')}}</label>
            </div>
            <div v-if="tabs==='1'">
                <template v-for='(i,index) in data' :key="index">
                    <div class="row m-0 panelList" v-if="i.done">
                    <div class="col-10 col-lg-11 mt-2 p-0">
                        <h4 class="title m-1 f-14 f-w-semibold">{{activitiesType(i.type, $ml)}} - {{i.subject}}</h4>
                        <div class="f-14">
                            <div v-if="i.notes!==undefined">
                                <label class="m-0 f-14 note p-1" v-if="i.notes[i.notes.length-1]!==undefined" v-html="filterNameNot(i.notes[i.notes.length-1].text)"></label>
                                <label class="m-0 f-14 note p-1 text-danger clickable" id="not" title="Daha Fazla" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SHOW_MORE')}}</label>
                                <div class="dropdown-menu light-blue-border border-radius-20 f-14 multiChoose dropMenu p-1" aria-labelledby="not">
                                    <ul class="list-unstyled p-2"  style="height:250px;overflow-y:scroll">
                                        <li v-for="not in i.notes">
                                            <label class="m-0 f-14 text-danger w-100">{{formatDate(new Date(not.created_at.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                                            <label class="m-0 f-14 text-dark" v-if="not!==undefined" v-html="not.text"></label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="f-14" >
                            <label class="m-0 f-14 text-danger" v-if="i.doneDate!==undefined">{{formatDate(new Date(i.doneDate.$date), "Do MMMM YYYY HH:MM:SS")}} - </label>
                            <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                                <label class="m-0 f-14" v-if='data[index].cuid && u._id.$oid===data[index].cuid.$oid'><i class="icon-solid-profil f-14"></i> {{u.name}} {{u.surName}} -</label>
                            </template>
                            <label class="m-0 f-14 clickable" v-if="i.contactId !== undefined" @click="contactCard(i.contactId[0]._id.$oid)"><i class="icon-solid-kisi f-14"></i> {{i.contactId[0].n}} {{i.contactId[0].sn}} -</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-kisi f-14"></i> {{$ml.get('EMPTY')}} -</label>
                            <label class="m-0 f-14 clickable" v-if="i.orgId !== undefined" @click="organizationCard(i.orgId[0]._id.$oid)"><i class="icon-solid-firmalar f-14"></i> {{truncate(i.orgId[0].name, 30)}}</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-firmalar f-14"></i> {{$ml.get('EMPTY')}}</label>
                        </div>
                    </div>
                </div>
                </template>
            </div>
            <div v-if="tabs==='2'">
                <template v-for='(i,index) in data' :key="index">
                    <div class="row m-0 mt-2 mb-2" v-if='i.orgId!==undefined && deal.orgId && deal.orgId._id && deal.orgId._id.$oid===i.orgId[0]._id.$oid && i.done'>
                    <div class="col-10 col-lg-11 mt-2 p-0">
                        <h4 class="title m-1 f-14 f-w-semibold">{{activitiesType(i.type, $ml)}} - {{i.subject}}</h4>
                        <div class="f-14">
                            <div v-if="i.notes!==undefined">
                                <label class="m-0 f-14 note p-1" v-if="i.notes[i.notes.length-1]!==undefined" v-html="filterNameNot(i.notes[i.notes.length-1].text)"></label>
                                <label class="m-0 f-14 note p-1 text-danger clickable" id="not" title="Daha Fazla" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SHOW_MORE')}}</label>
                                <div class="dropdown-menu light-blue-border border-radius-20 f-14 multiChoose dropMenu p-1" aria-labelledby="not">
                                    <ul class="list-unstyled p-2"  style="height:250px;overflow-y:scroll">
                                        <li v-for="not in i.notes">
                                            <label class="m-0 f-14 text-danger w-100">{{formatDate(new Date(not.created_at.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                                            <label class="m-0 f-14 text-dark"  v-if="not!==undefined" v-html="not.text"></label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="f-14">
                            <label class="m-0 f-14 text-danger" v-if="i.doneDate!==undefined">{{formatDate(new Date(i.doneDate.$date), "Do MMMM YYYY HH:MM:SS")}} - </label>
                            <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                                <label class="m-0 f-14" v-if='data[index].cuid && u._id.$oid===data[index].cuid.$oid'><i class="icon-solid-profil f-14" ></i> {{u.name}} {{u.surName}} -</label>
                            </template>
                            <label class="m-0 f-14 clickable" v-if="i.contactId !== undefined" @click="contactCard(i.contactId[0]._id.$oid)"><i class="icon-solid-kisi f-14"></i> {{i.contactId[0].n}} {{i.contactId[0].sn}} -</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-kisi f-14"></i> {{$ml.get('EMPTY')}} -</label>
                            <label class="m-0 f-14 clickable" v-if="i.orgId !== undefined" @click="organizationCard(i.orgId[0]._id.$oid)"><i class="icon-solid-firmalar f-14"></i> {{truncate(i.orgId[0].name, 30)}}</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-firmalar f-14"></i> {{$ml.get('EMPTY')}}</label>
                        </div>
                    </div>
                </div>
                </template>
            </div>
            <div v-if="tabs==='3'">
                <template v-for='(i,index) in data' :key="index">
                    <div class="row m-0 mt-2 mb-2" v-if='i.contactId!==undefined && deal.contactId && deal.contactId._id && deal.contactId._id.$oid===i.contactId[0]._id.$oid && i.done'>
                    <div class="col-10 col-lg-11 mt-2 p-0">
                        <h4 class="title m-1 f-14 f-w-semibold">{{activitiesType(i.type, $ml)}} - {{i.subject}}</h4>
                        <div class="f-14">
                            <div v-if="i.notes!==undefined">
                                <label class="m-0 f-14 note p-1" v-if="i.notes[i.notes.length-1]!==undefined"  v-html="filterNameNot(i.notes[i.notes.length-1].text)"></label>
                                <label class="m-0 f-14 note p-1 text-danger clickable" id="not" title="Daha Fazla" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SHOW_MORE')}}</label>
                                <div class="dropdown-menu light-blue-border border-radius-20 f-14 multiChoose dropMenu p-1" aria-labelledby="not">
                                    <ul class="list-unstyled p-2"  style="height:250px;overflow-y:scroll">
                                        <li v-for="not in i.notes">
                                            <label class="m-0 f-14 text-danger w-100">{{formatDate(new Date(not.created_at.$date), "Do MMMM YYYY HH:MM:SS")}}</label>
                                            <label class="m-0 f-14 text-dark"  v-if="not!==undefined" v-html="not.text"></label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="f-14" >
                            <label class="m-0 f-14 text-danger" v-if="i.doneDate!==undefined">{{formatDate(new Date(i.doneDate.$date), "Do MMMM YYYY HH:MM:SS")}} - </label>
                            <template v-for='u in users' :key="u._id ? u._id.$oid : u.name">
                                <label class="m-0 f-14" v-if='data[index].cuid && u._id.$oid===data[index].cuid.$oid'><i class="icon-solid-profil f-14" ></i>{{u.name}} {{u.surName}} -</label>
                            </template>
                            <label class="m-0 f-14 clickable" v-if="i.contactId !== undefined" @click="contactCard(i.contactId[0]._id.$oid)"><i class="icon-solid-kisi f-14"></i> {{i.contactId[0].n}} {{i.contactId[0].sn}} -</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-kisi f-14"></i> {{$ml.get('EMPTY')}} -</label>
                            <label class="m-0 f-14 clickable" v-if="i.orgId !== undefined" @click="organizationCard(i.orgId[0]._id.$oid)"><i class="icon-solid-firmalar f-14"></i> {{truncate(i.orgId[0].name, 30)}}</label>
                            <label class="m-0 f-14" v-else><i class="icon-solid-firmalar f-14"></i> {{$ml.get('EMPTY')}}</label>
                        </div>
                    </div>
                </div>
                </template>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        
    </div>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import { activityType as activitiesType } from '@/services/resultTableFormatters'
import { truncate } from '@/services/gridFormatters'
export default {
    name: 'completeShowPanel',
    data () {
        return {
            activityId:"",
            selectDate:{
                start:"2022-01-10",
                end:"2022-01-15"
            },
            filter:"",
            dealLogs:[],
            dealLogPathName:""
        }
    },
    computed: {
        ...mapState([
            'baseUrl'
        ]),
    },
    props:["data","field","tabs","contactId","deal","deals","users","organization","contact","array"],
    methods:{
        activitiesType,
        truncate,
        formatDate(value, format){
            return this.$moment(value).format(format)
        },
        filterNameNot(value){
            if (!value) return '';
            value = String(value);
            if (value.length > 60) {
                return value.substring(0, 60) + '...';
            }
            return value;
        },
        update(){
            let url = "updateActivity"
            let dataObj={}
            let obj={}
            obj={
                "done":true
            }
            dataObj["objId"]=this.activityId
            dataObj["updateObj"]=obj
            this.postActivities(url,dataObj)
        },
        postActivities(url,obj){
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Aktivite güncellendi!',
                        text: res.data.status.desc 
                    })
                    this.$emit('refleshData')
                    $('#activity').modal('hide')
                    //this.$emit('getData',res.data.content.activities)
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        organizationCard(id){
            if(id!==""){
                localStorage.orgId=id
                this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        dealCard(id){
            if(id!==""){
                localStorage.dealId=id
                this.updateDealId(id)
                window.open('/dealCard/'+id, '_blank');
            }
        },
        getEventLogsF(){
            var form = {}
            form.filter = { dealId:this.$route.params.dealId }
            // form.beginDate = this.selectDate.start
            // form.endDate = this.selectDate.end
            this.getEventLogs(form).then((res)=>{
                return res
            }).then((res)=>{
                this.dealLogs=res.content.logs
            })
        },
        ...mapActions([
            'updateOrgId',
            'updateContactId',
            'updateDealId',
            'getEventLogs',
        ]),
    },
    created(){
       this.dealLogPathName=(window.location.pathname).split("/",2).pop()
       this.$root.$refs.completeShowPanel=this
    },
    mounted(){
        this.dealLogPathName=(window.location.pathname).split("/",2).pop()
        if(this.dealLogPathName==='dealCard'){
            this.getEventLogsF();
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iptal:before{
    color:red
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.btnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.btnStyle button.active {
  background-color: #66D0FF!important;
  border: 1px solid #66D0FF;
  color: white;
}
.dealBtnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.dealBtnStyle button.active {
  background-color: #66D0FF!important;
  border: 1px solid #66D0FF;
  color: white;
}
.clickable{
    cursor: pointer;
}
.note :deep(p){
    margin: 0px;
}
</style>
